module.exports = __webpack_public_path__ + "2af27c57cbd2871d5e7450bda2d84229.woff";